/*
 * @Author: Ashley.Liu
 * @Date: 2022-11-23 13:59:16
 * @LastEditTime: 2022-12-21 18:11:12
 * @Description: copy
 */
import Vue from 'vue'
import Copy from '../components/copy/copy.vue'
import { addClass } from '../utils/dom'
import VueClipboard from 'vue-clipboard2'
// import CopySvg from '@/assets/copy-line.svg'
Vue.use(VueClipboard)

const COPY_CLASS_GEN_WHEN_ENTER = 'as-copy-gen-when-enter'
function getValue(binding) {
  if (typeof binding.value === 'function') {
    return binding.value()
  } else {
    return binding.value
  }
}

function mouseEnter(el, binding) {
  return () => {
    binding.__contentText__ = getValue(binding)

    if (binding.modifiers.parent) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = window.getComputedStyle(el).font
      const metrics = context.measureText(binding.__contentText__).width
      const parentWidth = el.parentNode.getBoundingClientRect().width - 60
      binding.__contentOverflow__ = parentWidth < metrics
    }

    if (binding.__copyEl__) {
      binding.__copyEl__ = null
      binding.__targetComponent__?.doDestroy()
    }
    removeAllCopyButtonEl(el)
    let targetAppendEl = binding.__contentOverflow__ ? el.parentNode : el

    const CopyButton = Vue.extend(Copy)
    let component = new CopyButton().$mount()
    component.content = binding.__contentText__
    binding.arg && (component.fontSize = binding.arg)
    if (binding.__contentOverflow__) {
      component.position = 'center'
    } else if (binding.modifiers.right) {
      component.position = 'right'
    } else {
      component.position = 'relative'
    }
    binding.__copyEl__ = component.$el
    binding.__targetComponent__ = component
    targetAppendEl.appendChild(binding.__copyEl__)
    setTimeout(() => {
      addClass(binding.__copyEl__, COPY_CLASS_GEN_WHEN_ENTER)
    }, 0)
  }
}
function mouseLeave(el, binding) {
  return () => {
    let targetAppendEl = binding.__contentOverflow__ ? el.parentNode : el
    if (binding.__copyEl__ && targetAppendEl.contains(binding.__copyEl__)) {
      targetAppendEl.removeChild(binding.__copyEl__)
      binding.__copyEl__ = null
    }
    binding.__copyEl__ = null
  }
}
function removeAllCopyButtonEl() {
  const arr = document.body.getElementsByClassName(COPY_CLASS_GEN_WHEN_ENTER)
  for (let i = arr.length - 1; i >= 0; i--) {
    if (arr[i] != null) {
      arr[i].parentNode.removeChild(arr[i])
    }
  }
}

function addEvent(el, binding) {
  el.$copyBinding = binding
  const targetAddEventEl = binding.modifiers.parent ? el.parentNode : el
  // mouseEnter(targetAddEventEl, binding)()
  binding.__mouseEnter__ = mouseEnter(el, binding)
  binding.__mouseLeave__ = mouseLeave(el, binding)
  targetAddEventEl.onmouseenter = binding.__mouseEnter__
  targetAddEventEl.onmouseleave = binding.__mouseLeave__
}
function removeEvent(el, binding) {
  mouseLeave(el, binding)()
  el.parentNode && (el.parentNode.onmouseenter = null)
  el.parentNode && (el.parentNode.onmouseleave = null)
  el.onmouseenter = null
  el.onmouseleave = null
}
export default {
  name: 'copy',
  inserted: function (el, binding) {
    if (getValue(binding)) {
      addEvent(el, binding)
    }
  },
  componentUpdated: function (el, binding) {
    removeEvent(el, binding)
    addEvent(el, binding)
  },
  unbind: function (el, binding) {
    removeEvent(el, binding)
  },
}
